import Vue from "vue";
import VueGtag from "vue-gtag";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

const trackingId = "UA-140122993-15";

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: {
    id: trackingId,
    params: {
      send_page_view: true
    }
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

// alert(
//   "Please come visit our Campbellton Community Investment Corridor Project: A Main Street for Southwest Atlanta event on June 28, 2022, from 6 p.m. to 7:30 p.m., to see updated information on the transit project! In the meantime, please see previous materials from the project in this room. Note, some of this information may be out of date."
// );
